<!--
 * @Author: your name
 * @Date: 2021-12-31 11:06:09
 * @LastEditTime: 2022-01-12 08:49:25
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /cmdc-web-v/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/product/brand/brandProtocol.vue
-->
<template>
  <div class="brand-protocol">
    <h1 class="brand-title">品牌须知</h1>
    <div class="brand-content">
      <p>请确保您充分知悉并符合以下基本条件及说明：</p>
      <p>1.提交的信息真实，商标注册证、品牌授权书等证明文件有效。</p>
      <p>
        2.易派客有权对品牌、商标信息和证明文件进行不定期抽查，以核实真实性、合法性和效力状态，易派客有权就前述内容，要求提交更多信息和证明文件。
      </p>
      <p>
        3.在易派客平台销售的商品，必须与品牌相符，且不侵犯他人知识产权，易派客有权对违反前述要求的商品进行下架处理。
      </p>
    </div>
    <div class="button">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="agreeNext">同意并下一步</el-button>
    </div>
    <div class="hint">如果您在申请品牌的过程中遇到问题，请拔打电话0898-65860395或发送邮件至wzwudj@sinopec.com</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    agreeNext() {
      this.$store.state.tagsList.map((item, index) => {
        if (item.fullPath == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      const { from } = this.$route.query;
      if (from != undefined && from == 'createProduct') {
        this.$router.push({
          path: '/brandApply',
          query: {
            from: 'createProduct',
          },
        });
      } else {
        this.$router.push({
          path: '/brandApply',
        });
      }
    },
    cancel() {
      this.$store.state.tagsList.map((item, index) => {
        if (item.fullPath == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.brand-protocol {
  padding: 20px;
  background: #fff;
  .brand-title {
    text-align: center;
    font-size: 18px;
  }
  .brand-content {
    p:first-child {
      color: #2587ff;
    }
    p {
      margin-top: 20px;
      font-size: 14px;
    }
  }
  .button {
    margin-top: 20px;
    text-align: center;
    ::v-deep .el-button {
      min-width: 80px;
      height: 30px;
      font-size: 14px;
      padding: 0 10px;
      /* line-height: 30px; */
      text-align: center;
      & + .el-button {
        margin-left: 20px;
      }
    }
  }
  .hint {
    margin-top: 20px;
    color: #999999;
    font-size: 14px;
    text-align: center;
  }
}
</style>
